import React from 'react';

import { MiniModalForYouThreadsListHidesInput } from './MiniModalForYouThreadsListHidesInput';

/**
 * Wrapper for chat input that conditionally hides it based on tabs view.
 *
 * When `hasTabsView` is false the wrapper is a transparent pass-through.
 * When `hasTabsView` is true it delegates to MiniModalForYouThreadsListHidesInput
 * (ActiveTab + For You navigation) and hides the input only on the threads-list view.
 */
export const MiniModalTabAwareChatInput = ({
	hasTabsView,
	children,
}: {
	hasTabsView: boolean;
	children: React.ReactNode;
}): React.JSX.Element => {
	if (!hasTabsView) {
		return <>{children}</>;
	}
	return <MiniModalForYouThreadsListHidesInput>{children}</MiniModalForYouThreadsListHidesInput>;
};
